import { computed, observable, action } from 'mobx';
import { Shade } from './Shade';
import { Size } from './Size';
import { InventoryStatus } from '../../constants/InventoryStatuses';

export interface IFilters {
    [key: string]: string[];
}

export class ProductGridSettings {
    @observable public sortValue: string = '';
    @observable public enableSortByInventoryStatus: boolean = false;
    @observable public sortInventoryStatuses: InventoryStatus[] = [];
    @observable public enableBackorder: boolean = false;

    @action
    public setSortCriteria = (sort: string) => {
        this.sortValue = sort;
    };

    @action
    public setSortByInventoryStatus = (
        sortInventoryStatuses: InventoryStatus[],
        enableBackorder: boolean = false
    ) => {
        this.sortInventoryStatuses = sortInventoryStatuses;
        this.enableSortByInventoryStatus = true;
        this.enableBackorder = enableBackorder;
    };

    private sanitizeSelectionParams = (selectionParam: string) => {
        return selectionParam.split(' ').join('_');
    };

    @computed
    private get sortCriteria() {
        const sanitizedSortCriteria = this.sanitizeSelectionParams(this.sortValue);

        return [sanitizedSortCriteria];
    }

    @computed
    private get sort() {
        return this.sortCriteria ? { sort: this.sortCriteria } : {};
    }

    public toJSON() {
        return {
            sort: this.sort
        };
    }

    public shadeSizeToJSON(selectedShade: Shade, selectedSize: Size) {
        return {
            shade: selectedShade ? this.sanitizeSelectionParams(selectedShade.name) : '',
            size: selectedSize ? this.sanitizeSelectionParams(selectedSize.value) : ''
        };
    }
}
